export const entityTextFormKey: Record<string, string> = {
  form_edit_form: 'form_edit_form',
  form_edit_list: 'form_edit_list',
  form_edit_column: 'form_edit_list',
  form_edit_filter: 'form_edit_list',
};
